export const DOCUMENT_LIBRARY = {
  acuseSection: 'document-library-acuse-section',
  firmaSection: 'document-library-firma-section',
  templateCard: 'document-library-template-card',
  generateButton: 'document-library-generate-button',
  policyPdfButton: 'policy-pdf-download-button',
  employeeDocsSelect: 'document-library-employee-docs-select',
  employeeDocRow: 'document-library-employee-doc-row',
  employeeDocPdfButton: 'document-library-employee-doc-pdf-button',
  employeeDocStatusBadge: 'document-library-employee-doc-status-badge',
  sendForReviewButton: 'document-library-send-for-review-button',
  uploadSignatureButton: 'document-library-upload-signature-button',
  viewSignedFileButton: 'document-library-view-signed-file-button',
  legalReason: 'document-library-legal-reason',
  employeeDetailDocumentsTab: 'employee-detail-documents-tab',
};

export const EXPEDIENTE_CHECKLIST = {
  root: 'expediente-checklist',
  autoItem: 'expediente-checklist-auto-item',
  externalCheckbox: 'expediente-checklist-external-checkbox',
  commentInput: 'expediente-checklist-comment-input',
  saveCommentButton: 'expediente-checklist-save-comment-button',
};

export const UPLOAD_SIGNATURE_DIALOG = {
  dialog: 'upload-signature-dialog',
  fileInput: 'upload-signature-file-input',
  submitButton: 'upload-signature-submit-button',
};

export const DOCUMENT_GENERATE_DIALOG = {
  dialog: 'document-generate-dialog',
  employeeSelect: 'document-generate-employee-select',
  fieldInputPrefix: 'document-generate-field',
  draftTextarea: 'document-generate-draft-textarea',
  submitButton: 'document-generate-submit-button',
  conflictWarning: 'document-generate-conflict-warning',
  confirmReplaceButton: 'document-generate-confirm-replace-button',
};

export const DOCUMENT_VIEW_DIALOG = {
  dialog: 'document-view-dialog',
  downloadPdfButton: 'document-view-download-pdf-button',
  closeButton: 'document-view-close-button',
};

export const EXPEDIENTE_POLICIES = {
  viewButton: 'expediente-view-document-button',
  ackButton: 'expediente-acknowledge-button',
};

export const MY_SALARY_SECTION = {
  section: 'my-salary-section',
  currentSalary: 'my-salary-current-total',
  hiddenMessage: 'my-salary-hidden-message',
  historyRow: 'my-salary-history-row',
  baseSalary: 'my-salary-base-salary',
  componentRow: 'my-salary-component-row',
};

export const EXPEDIENTE_TABS = {
  tabList: 'expediente-tabs-list',
  tabDatos: 'expediente-tab-datos',
  tabSalario: 'expediente-tab-salario',
  tabPoliticas: 'expediente-tab-politicas',
  tabDocumentos: 'expediente-tab-documentos',
  tabIncidencias: 'expediente-tab-incidencias',
  contentDatos: 'expediente-content-datos',
  contentSalario: 'expediente-content-salario',
  contentPoliticas: 'expediente-content-politicas',
  contentDocumentos: 'expediente-content-documentos',
  contentIncidencias: 'expediente-content-incidencias',
};

export const CORRECTION_INBOX = {
  page: 'correction-inbox-page',
  filterButtonPrefix: 'correction-inbox-filter-button',
  emptyState: 'correction-inbox-empty-state',
  list: 'correction-inbox-list',
  resolveButtonPrefix: 'correction-inbox-resolve-button',
};

export const FAILED_EMAILS_INBOX = {
  page: 'failed-emails-inbox-page',
  emptyState: 'failed-emails-inbox-empty-state',
  list: 'failed-emails-inbox-list',
  row: 'failed-emails-inbox-row',
  resolveButtonPrefix: 'failed-emails-inbox-resolve-button',
  navLink: 'admin-nav-envios-fallidos',
};

export const VERSION_HISTORY = {
  dialogTriggerPrefix: 'version-history-dialog-trigger',
  dialog: 'version-history-dialog',
  employeeSelect: 'version-history-employee-select',
  versionRow: 'version-history-version-row',
  generatedByLabel: 'version-history-generated-by-label',
};

export const MY_DATA = {
  section: 'my-data-section',
  fieldValuePrefix: 'my-data-field-value',
  requestCorrectionButton: 'my-data-request-correction-button',
  requestCorrectionTextarea: 'my-data-request-correction-textarea',
  requestCorrectionSubmitButton: 'my-data-request-correction-submit-button',
  requestsList: 'my-data-requests-list',
  privacyNotice: 'my-data-privacy-notice',
};

export const EXPEDIENTE_SIGNABLE_DOCS = {
  section: 'expediente-signable-docs-section',
  row: 'expediente-signable-doc-row',
  statusBadge: 'expediente-signable-doc-status-badge',
  viewButton: 'expediente-signable-doc-view-button',
  markReviewedButton: 'expediente-signable-doc-mark-reviewed-button',
  viewSignedFileButton: 'expediente-signable-doc-view-signed-file-button',
};

export const SIGNED_FILE_PREVIEW = {
  dialog: 'signed-file-preview-dialog',
  downloadButton: 'signed-file-preview-download-button',
};

export const IMPLEMENTATION_GUIDE = {
  openButton: 'implementation-guide-open-button',
  dialog: 'implementation-guide-dialog',
  semaforoTable: 'implementation-guide-semaforo-table',
  downloadPdfButton: 'implementation-guide-download-pdf-button',
};

export const SIGNATURE_STATUS_PANEL = {
  section: 'signature-status-panel-section',
  row: 'signature-status-panel-row',
  reminderBanner: 'signature-status-panel-reminder-banner',
  reminderBadge: 'signature-status-panel-reminder-badge',
  summaryBadge: 'signature-status-panel-summary-badge',
};

export const ACTA_ADMINISTRATIVA_HISTORY = {
  section: 'acta-administrativa-history-section',
  row: 'acta-administrativa-history-row',
  createdAtLabel: 'acta-administrativa-history-created-at',
  emptyState: 'acta-administrativa-history-empty-state',
};

export const MANUAL_CONFIRMATION = {
  policyButton: 'policy-manual-confirm-button',
  policyBadge: 'policy-manual-confirm-badge',
  signableButton: 'signable-doc-manual-confirm-button',
  signableBadge: 'signable-doc-manual-confirm-badge',
  dialog: 'manual-confirm-dialog',
  noteInput: 'manual-confirm-note-input',
  submitButton: 'manual-confirm-submit-button',
};
